import React from "react"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import PrimaryButton from "./Button/PrimaryButton"
import ListFilterItem from "./ListFilterItem/ListFilterItem"
import { useUrlParams } from '../Hooks/useUrlParams';

const filterStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    height: '100%',
    '& .filterItems': {
        flex: 1,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    },
    '& .filterFooter': {
        padding: '16px 0',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        backgroundColor: '#fff'
    }
};

export const Filtruoti = ({ setOn, setFilter, setLoading }) => {
    const { t } = useTranslation();
    const { params } = useUrlParams();

    const handleFilter = () => {
        setOn(false);
        if (Object.keys(params).length > 0) {
            // Convert URL params to filter format
            const filters = {};
            Object.entries(params).forEach(([key, value]) => {
                filters[key] = Array.isArray(value) ? value : [value];
            });
            setFilter(filters);
            if (setLoading) {
                setLoading(true);
            }
        }
    };

    return (
        <Box sx={filterStyle}>
            <h3>{t('filtruoti')}</h3>
            
            <Box className="filterItems">
                <ListFilterItem
                    size='small'
                    options={t('lytys', { returnObjects: true })}
                    optionsText={t('lytysText', { returnObjects: true })}
                    paramName={"Lytis"}
                    label={t('lytysLabel')}
                />
                <ListFilterItem
                    size='small'
                    options={t('amziai', { returnObjects: true })}
                    optionsText={t('amziaiText', { returnObjects: true })}
                    label={t('amziusLabel')}
                    paramName={"Amzius"}
                />
                <ListFilterItem
                    size='small'
                    options={t('padetys', { returnObjects: true })}
                    optionsText={t('padetysText', { returnObjects: true })}
                    paramName={"Padetis"}
                    label={t('padetysLabel')}
                />
                <ListFilterItem
                    size='small'
                    options={t('laikai', { returnObjects: true })}
                    optionsText={t('laikaiText', { returnObjects: true })}
                    paramName={"Laikas"}
                    label={t('laikaiLabel')}
                />
                <ListFilterItem
                    size='small'
                    options={t('pareigoms', { returnObjects: true })}
                    optionsText={t('pareigomsText', { returnObjects: true })}
                    paramName={"Pareigos"}
                    label={t('pareigomsLabel')}
                />
                <ListFilterItem
                    options={t('kompiuteriai', { returnObjects: true })}
                    size='small'
                    optionsText={t('kompiuteriaiText', { returnObjects: true })}
                    paramName={"Kompiuteris"}
                    label={t('kompiuteriaiLabel')}
                />
                <ListFilterItem
                    options={t('issilavinimai', { returnObjects: true })}
                    size='small'
                    optionsText={t('issilavinimaiText', { returnObjects: true })}
                    paramName={"Issilavinimas"}
                    label={t('issilavinimaiLabel')}
                />
                <ListFilterItem
                    options={t('religijos', { returnObjects: true })}
                    size='small'
                    optionsText={t('religijosText', { returnObjects: true })}
                    paramName={"Religija"}
                    label={t('religijosLabel')}
                />
                <ListFilterItem
                    options={t('LGBT', { returnObjects: true })}
                    size='small'
                    optionsText={t('LGBTText', { returnObjects: true })}
                    paramName={"LGBT"}
                    label={t('LGBTLabel')}
                />
                               
                <ListFilterItem
                    options={t('negalios', { returnObjects: true })}
                    size='small'
                    optionsText={t('negaliosText', { returnObjects: true })}
                    paramName={"Negalia"}
                    label={t('negaliosLabel')}
                />
            </Box>

            <Box className="filterFooter">
                <PrimaryButton
                    onClick={handleFilter}
                    sx={{ width: '100%' }}
                >
                    {t('filtruoti')}
                </PrimaryButton>
            </Box>
        </Box>
    )
}